@if (eventId(); as id) {
  <app-event-processing-panel [eventId]="id" [processingMode]="processingMode()" />
}
